export const COMMENT_STATE_KEYS = {
	ALL: 'ALL',
	JUST_ADDED: 'JUST_ADDED',
	PUBLISHED: 'PUBLISHED',
	REJECTED: 'REJECTED',
};

export const COMMENT_STATE_LABELS = {
	ALL: 'همه',
	JUST_ADDED: 'در انتظار تایید',
	PUBLISHED: 'تایید شده',
	REJECTED: 'رد شده',
};

export const COMMENT_STATE_STATES = {
	ALL: [],
	JUST_ADDED: ['just_added'],
	PUBLISHED: ['published'],
	REJECTED: ['rejected'],
};
